"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findNestedValue = findNestedValue;
function findNestedValue() {
  var obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var keysChain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var key = keysChain.shift();
  if (!key || !obj[key]) {
    return undefined;
  }
  if (keysChain.length === 0) {
    return obj[key];
  }
  return findNestedValue(obj[key], keysChain);
}